// extracted by mini-css-extract-plugin
module.exports = {"container":"MembershipCard_container__I4bVk","content":"MembershipCard_content__NFH6P","spin":"MembershipCard_spin__7b_sr","loader":"MembershipCard_loader__d0n7K"};